<template>
	<div class="section-loader">
		<div class="loader">
			<div></div>
			<div></div>
		</div>
	</div>
</template>

<script>
export default {
	created() {
		// Attach an "onload" eventListener to the DOM that will emit a "window-loaded" event
		window.addEventListener("load", () => this.$emit("window-loaded"));
		// Fetch data from Firestore only after DOM has loaded
		this.$on("window-loaded", () =>
			this.$store
				.dispatch("fetchDefaults")
				.then(() => {
					// Emit a "defaults-fetched" event, that will be intercepted by the parent component
					this.$emit("defaults-fetched", true);
					// Fetch skills
					this.$store.dispatch("fetchSkills");
					// this.$store.dispatch("fetchCategories");
					this.$store.dispatch("fetchPortfolio");
					this.$store.dispatch("fetchExperience");
				})
				.catch(e => {
					// Log any errors to the user & console
					this.$toast.fire({
						icon: "error",
						title: "Poor connection! Reloading..."
					});
					console.error(e);
					setTimeout(() => {
						location.reload();
					}, 1500);
				})
		);
	}
};
</script>
